import { render } from "./Breadcrumb.vue?vue&type=template&id=40bb0a7b&scoped=true"
import script from "./Breadcrumb.vue?vue&type=script&lang=js"
export * from "./Breadcrumb.vue?vue&type=script&lang=js"

import "./Breadcrumb.vue?vue&type=style&index=0&id=40bb0a7b&scoped=true&lang=css"

import exportComponent from "/mnt/data/workspace/risetai/riset.ai-website/Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bb0a7b"]])

export default __exports__